import React, { useState } from 'react';
import { withRouter, Link } from "react-router-dom";
import { Form, Input, Button } from 'antd';

import './Register.css';;

const Register = (props) => {

  const [response, setResponse] = useState('Already received a password?');
  const [showLogIn, setShowLogin] = useState(true);
  const [submitting, setSubmitting] = useState(false);


  const onSubmit = async (values) => {
    setSubmitting(true);
    let res = await fetch('/api/register', {
        method: 'POST',
        headers: new Headers({ 'content-type': 'application/json' }),
        credentials: 'include',
        body: JSON.stringify(values)
      });
    let data = await res.json();
    console.log(data);
    if (!data.error) {
      setResponse(`${data.msg}.`);
      setShowLogin(true);
      props.history.push("/login");
    } else {
      setShowLogin(false);
      setSubmitting(false);
      setResponse(data.error);
    }
  };

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div className="registerForm formWrapper">
      <Form
        name="basic"
        initialValues={{ remember: false }}
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}>
        <p>
        Enter your email address to get a password
        </p>
        <Form.Item
          name="email"
          rules={[{ required: true, message: 'Please input your email' }]}>
          <Input
            placeholder="email"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" loading={submitting} htmlType="submit">
            Get Password
          </Button>
        </Form.Item>
        <p>
          {response}&nbsp;&nbsp;
          {showLogIn && (
            <Link to="/login">Log In</Link>
          )}
        </p>
      </Form>
    </div>
  );
};

export default withRouter(Register);